import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65afe742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-organizations-root-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Vaše organizacije ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "address" }
const _hoisted_9 = { class: "action" }
const _hoisted_10 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAdministratorOrganizationsRootListFormCreateIndexVue = _resolveComponent("AppAdministratorOrganizationsRootListFormCreateIndexVue")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppAdministratorOrganizationsRootListFormRemoveIndexVue = _resolveComponent("AppAdministratorOrganizationsRootListFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AppAdministratorOrganizationsRootListFormCreateIndexVue, { onGetUserOrganizationsForAdministration: _ctx.getUserOrganizationsForAdministration }, null, 8, ["onGetUserOrganizationsForAdministration"])
      ]),
      (_ctx.organizations.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizations, (organization) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: organization.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(organization.content.name), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(organization.content.address) + ", " + _toDisplayString(organization.content.city) + ", " + _toDisplayString(organization.content.country), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    class: "el-button el-button--grey el-button--square",
                    to: { name: 'AppAdministratorOrganizationsDetailIndexVue', params: { id: organization.id } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoFilled)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createVNode(_component_AppAdministratorOrganizationsRootListFormRemoveIndexVue, {
                    isRemoveOrganizationDisabled: _ctx.isRemoveOrganizationDisabled(organization.id),
                    organization: organization,
                    onGetUserOrganizationsForAdministration: _ctx.getUserOrganizationsForAdministration
                  }, null, 8, ["isRemoveOrganizationDisabled", "organization", "onGetUserOrganizationsForAdministration"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, " Nema podataka... "))
    ])
  ]))
}